import {SmartColumn} from "../../../../../../../common/smart-table/smart-table.model";
import {PriceHistoryEntry} from "../../../../../../../../models/articles/price/history";
import {Translate} from "../../../../../../../../hooks/translate.hook";
import {FieldType} from "../../../../../../../common/smart-table/smart-table.field-config";
import {User} from "../../../../../../../../models/users/user/user";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "antd";

export const columnsFactory = (
    t: Translate,
    downloadSourceFile: (e: PriceHistoryEntry) => void
): SmartColumn<PriceHistoryEntry>[] => {
    return [
        {
            name: "date",
            visibleName: t("DATE"),
            dataIndex: "date",
            type: FieldType.DATETIME
        },
        {
            name: "value",
            visibleName: t("PRICE"),
            dataIndex: "value",
            type: FieldType.STRING
        },
        {
            name: "minimalValue",
            visibleName: t("PRICES.MINIMAL_PRICE"),
            dataIndex: "minimalValue",
            type: FieldType.STRING
        },
        {
            name: "source",
            visibleName: t("PRICES.HISTORY.SOURCE"),
            dataIndex: "source",
            type: FieldType.STRING
        },
        {
            name: "initiator",
            visibleName: t("USER.TITLE"),
            dataIndex: "initiator",
            type: FieldType.CUSTOM,
            render: (v: User | null) => v ? v.firstName + ' ' + v.lastName : '-'
        },
        {
            name: "source",
            visibleName: "",
            dataIndex: "withSourceFile",
            type: FieldType.CUSTOM,
            render: (v: boolean, item: PriceHistoryEntry) => v ?
                <Button
                    type={"text"}
                    onClick={() => downloadSourceFile(item)}
                    icon={<FontAwesomeIcon icon={["fas", "download"]} />}
                /> : null
        },
    ];
}